export const promptClasses = {
  wrapper:
    "outline-none w-full px-1 py-2 bg-transparent text-primary-text text-base placeholder-text-muted focus:outline-none transition-all duration-200 max-h-60 overflow-y-auto",
  code: "bg-black/10 dark:bg-white/10 px-0.5 py-0.5 rounded text-sm",
  codeBlock: "bg-inset px-2 py-2 mb-2 rounded text-sm whitespace-pre-wrap",
  blockquote: "border-l-2 border-indigo-100 dark:border-indigo-700 pl-2 py-1 my-1",
  bulletList: "list-disc pl-4",
  orderedList: "list-decimal pl-4",
  italic: "italic",
  bold: "font-bold",
};
